const initialState = {
    doctordata:[],
    hospitaldata: [], 
    
  };
  
  const SupViewDcotorReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_DATA_SUCCESS':
            return {... state, doctordata:action.payload};
            case 'FETCH_DATA1_SUCCESS':
            return {... state, hospitaldata:action.payload};
           
           
            
           
          


      default:
        return state;
    }
  };
  
  export default SupViewDcotorReducers;
  
  